import { renderPrompt } from '../services/promptsApi';

// The prompt text now lives in the backend prompt store (key: training.script)
// and is editable from Settings → Prompt. Interpolation happens server-side.
async function generateScript(formData) {
  const {
    numberOfCharacters,
    language,
    courseName,
    domains,
  } = formData;

  const domainNames = domains.map((domain) => domain.name).join(', ');
  const subDomainNames = domains
    .flatMap((domain) => domain.subDomain.map((sub) => sub.name))
    .join(', ');

  return renderPrompt('training.script', {
    language,
    courseName,
    numberOfCharacters,
    domainNames,
    subDomainNames,
  });
}

export { generateScript };
